/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-no-bind */
import {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';

import * as store from '@/store';
import sdk from '@/sdk';
import Text, {TextType, TextColor} from '@/components/Text';
import ConfirmDialog from '@/components/ConfirmDialog';
import toast, {ToastType} from '@/components/Toast';
import {feLogger, createBook} from '@/buried';
import styles from './index.module.scss';
import kuPiper from '@/middleware/kuPiper';
import {BOOK_PUBLIC_TYPE} from '@/constants/document/doc';
import {InheritRepo} from '@/Constant';
interface ConvertDocumentConfirmDialogProps {
    convertToCatalog?: {docGuid: string, inherit?: number, scope?: number, isPop?: boolean};
    curRepository?: Repository;
}

function ConvertToDirectory(props: ConvertDocumentConfirmDialogProps) {
    const intl = useIntl();
    const {
        convertToCatalog, curRepository,
    } = props;
    const [open, setOpen] = useState(false);
    const docGuid = convertToCatalog ? convertToCatalog.docGuid : '';
    // useEffect(() => {
    //     if (docGuid) {
    //         setOpen(true);
    //     }
    // }, [docGuid, convertToCatalog]);
    async function handleConfirm() {
        try {
            const ksServer = await sdk.getKsServer(curRepository);
            const result = await ksServer.convertToKnowledgeBasis(
                curRepository?.repositoryGuid || '',
                docGuid,
                convertToCatalog?.inherit,
                convertToCatalog?.scope
            );
            if (result) {
                toast({
                    content: result,
                    type: ToastType.Error,
                });
                setOpen(false);
                return;
            }
            if (convertToCatalog?.isPop === false) {
                const key = convertToCatalog?.scope === BOOK_PUBLIC_TYPE.isReaderPublic
                    ? 'OpenKnowledgeStatus'
                    : convertToCatalog?.inherit === InheritRepo.Inherit
                        ? 'OrdinaryKnowledgeStatus'
                        : convertToCatalog?.inherit === InheritRepo.Not_Inherit
                            ? 'SecrecyKnowledgeStatus'
                            : 'OrdinaryKnowledgeStatus';
                toast({
                    content: `已切换为${key === 'OrdinaryKnowledgeStatus' ? '普通知识本' :
                        key === 'OpenKnowledgeStatus' ? '公开知识本，默认公开可阅读' : '保密知识本'}`,
                    type: ToastType.Success,
                });
            }
            feLogger(createBook(
                {
                    'pageid': docGuid,
                    'position': '3',
                    'userid': sdk.as.user?.userGuid,
                }
            ));
            setTimeout(() => {
                location.reload();
            }, 200);
        } catch (error) {
            setOpen(false);
            const toastText = navigator.onLine ? 'convertErrorText' : 'notworkErrorText';
            toast({
                content: intl.formatMessage({id: toastText}),
                type: ToastType.Error,
            });
        }
    }

    useEffect(() => {
        if (docGuid && convertToCatalog?.isPop !== false) {
            setOpen(true);
        } else if (docGuid && convertToCatalog?.isPop === false) {
            handleConfirm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid, convertToCatalog]);

    function handleCancel() {
        setOpen(false);
    }
    return (
        <ConfirmDialog
            visible={open}
            headline={
                <div className={styles.convertToBookHead}>
                    {intl.formatMessage({id: 'indexMenuConvertToknowledgeBasis'})}</div>
            }
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            showCloseX
            width={388}
            className={styles.convertToBookBtn}
        >
            {/* <div className={styles.convertTitle}>
                <Text
                    type={TextType.T16}
                    color={TextColor.Dark}
                    className={'dialog-body-content-header'}
                >文档将涉及以下三项变化</Text>
            </div> */}
            <div className={styles.convertContent}>
                <Text>「权限继承」子文档继承知识本权限；</Text>
            </div>
            <div className={styles.convertContent}>
                <Text>「封面展示」知识本支持展示子文档目录；</Text>
            </div>
            <div className={styles.convertContent}>
                <Text>{kuPiper.openTextSlot('convertToDirectoryToastEnd')}</Text>
            </div>
        </ConfirmDialog>
    );
}

const ConvertToDirectoryImpl = store.connect([
    store.KEYS.CONVERTTOCATALOG_DOCUMENT,
    store.KEYS.CUR_REPOSITORY,
])(ConvertToDirectory);

export default ConvertToDirectoryImpl;
